
import { visitorService } from "@/service";
import { defineComponent, reactive, PropType, toRefs, watch, ref } from "vue";
import HouseItem from "./HouseItem.vue";

export interface HouseRef {
  onSearch(searchName: string): void;
}
export default defineComponent({
  name: "House",
  components: { HouseItem },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["change", "list"],
  setup(props, { emit }) {
    const search_value = ref("");
    const { data } = toRefs(props);
    const checkedHouse = ref({});
    const state = reactive({
      list: [],
      checked: []
    });
    const updateChecked = (val: any) => {
      checkedHouse.value = val;
      emit("change", val);
    };

    watch(
      () => data.value,
      now => {
        console.log(now, "house waatch");
        checkedHouse.value = now;
      }
    );

    const onLoad = async () => {
      try {
        const { data } = await visitorService.visitorTargetLists({
          target_type: 2,
          search_name: search_value.value,
          to_tree: 1
        });
        state.list = data.data;
      } catch (error) {
        state.list = [];
      }
    };

    const onSearch = async (from = "self") => {
      if (from === "index") search_value.value = "";
      state.list = [];
      await onLoad();
      if (from === "index") return state.list;
    };

    return {
      state,
      updateChecked,
      search_value,
      onSearch,
      checkedHouse
    };
  }
});
